import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem',
    },
    title: {
      width: '200px',
      height: '30px',
    },
  },
  locationSelector: {
    main: {
      padding: '1rem',
      marginBottom: '1rem',
    },
    origin: {
      marginBottom: '0.5rem',
    },
    box: {
      height: '40px',
    },
  },
  content: {
    main: {
      padding: '1.5rem',
    },
    row: {
      marginBottom: '1.5rem',
    },
    bar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    barFirst: {
      height: '150px',
    },
    barSecond: {
      height: '100px',
    },
  },
  legend: {
    main: {
      marginBottom: '0.5rem',
    },
    text: {
      padding: '0.5rem',
      height: '20px',
    },
  },
  disclaimer: {
    padding: '0.5rem',
    height: '20px',
  },
  pharagraph: {
    main: {
      marginTop: '1rem',
    },
    text: {
      height: '20px',
    },
  },
};

const SkeletonLightMonthlyHistogramMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, locationSelector, content, legend, disclaimer, pharagraph } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonLightMonthlyHistogramMobile"
    >
      <Row gutters>
        <Col style={header.main}>
          <Box className="fr-skeleton-box" style={header.box}>
            <Box className="fr-skeleton-element" style={header.title} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={locationSelector.main}>
          <Box className="fr-skeleton-box" style={{ padding: '1rem' }}>
            <Row gutters>
              <Col xs="12" style={locationSelector.origin}>
                <Box className="fr-skeleton-element" style={locationSelector.box} />
              </Col>
              <Col xs="12">
                <Box className="fr-skeleton-element" style={locationSelector.box} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={content.main}>
            <Row gutters style={content.row}>
              <Col xs="6" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barFirst} />
              </Col>
              <Col xs="6" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barSecond} />
              </Col>
            </Row>
            <Row gutters style={legend.main}>
              <Col xs="3">
                <Box className="fr-skeleton-element" style={legend.text} />
              </Col>
            </Row>
            <Row gutters>
              <Col xs="9">
                <Box className="fr-skeleton-element" style={disclaimer} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4" style={pharagraph.main}>
          <Box className="fr-skeleton-box" style={pharagraph.text} />
        </Col>
      </Row>
    </Box>
  );
};
SkeletonLightMonthlyHistogramMobile.componentName = 'SkeletonLightMonthlyHistogramMobile';

export default SkeletonLightMonthlyHistogramMobile;
